import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LaoDongPhoThong.css';
import './Home.css';
import logo from './logo.png';

// Icon components
const BrushIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Brush">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20h10l2-6H6z" fill={color} opacity=".15" />
      <path d="M14 9l5-5" />
      <path d="M13 8l3 3" />
      <path d="M6 14h10" />
    </g>
  </svg>
);

const ConstructIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Construct">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" fill={color} opacity=".15" />
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </g>
  </svg>
);

const HomeIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Home">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" fill={color} opacity=".15" />
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9,22 9,12 15,12 15,22" />
    </g>
  </svg>
);

const HeartIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Heart">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill={color} opacity=".15" />
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </g>
  </svg>
);

const LaoDongPhoThong: React.FC = () => {
	const navigate = useNavigate();
	const [navOpen, setNavOpen] = React.useState(false);
	React.useEffect(() => {
		document.title = 'Lao động phổ thông - Fconnect';
	}, []);

	return (
		<div className="home-page">
			{/* Header (reuse from Home) */}
			<header className="home-header">
				<div className="home-container header-inner">
					<div className="brand" onClick={() => { navigate('/'); setNavOpen(false); }}>
						<img src={logo} alt="Fconnect" />
					</div>
					<button
						className="nav-toggle"
						aria-label={navOpen ? 'Đóng menu' : 'Mở menu'}
						aria-expanded={navOpen}
						aria-controls="main-navigation"
						onClick={() => setNavOpen((o) => !o)}
					>
						{navOpen ? '✕' : '☰'}
					</button>
					<nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
						<Link to="/" onClick={() => setNavOpen(false)}>Trang chủ</Link>
						<Link to="/lao-dong-pho-thong" onClick={() => setNavOpen(false)}>Lao động phổ thông</Link>
						<Link to="/lao-dong-nong-nghiep" onClick={() => setNavOpen(false)}>Lao động nông nghiệp</Link>
						<Link to="/dich-vu-y-te" onClick={() => setNavOpen(false)}>Dịch vụ y tế</Link>
						<Link to="/privacy" onClick={() => setNavOpen(false)}>Chính sách bảo mật</Link>
						<Link to="/terms" onClick={() => setNavOpen(false)}>Điều khoản</Link>
						<Link to="/contact" onClick={() => setNavOpen(false)}>Liên hệ</Link>
						<Link to="/en" className="lang-link" onClick={() => setNavOpen(false)}>English</Link>
					</nav>
				</div>
			</header>
			<div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

			{/* Banner Section */}
			<section className="ldt-banner-section">
				<div className="ldt-banner-content">
					<div className="ldt-banner-text">
						<h2>Dịch vụ lao động phổ thông chất lượng cao</h2>
						<p>Giải pháp toàn diện cho mọi nhu cầu gia đình và văn phòng</p>
					</div>
					<div className="ldt-banner-visual">
						<div className="ldt-banner-icons">
							<BrushIcon size={48} color="#F57C00" />
							<ConstructIcon size={48} color="#F57C00" />
							<HomeIcon size={48} color="#F57C00" />
							<HeartIcon size={48} color="#F57C00" />
						</div>
					</div>
				</div>
			</section>

			{/* Content */}
			<section className="home-container">
				<header className="ldt-hero">
					<h1>Lao động phổ thông</h1>
					<p className="ldt-subtitle">Giải pháp nhân lực gia đình và đời sống hằng ngày: nhanh chóng, tin cậy, giá minh bạch.</p>
				</header>

				<div className="ldt-content">
					<section className="ldt-section">
						<h2 className="section-title">Các dịch vụ</h2>
						<div className="services-grid">
							<div className="service-card">
								<div className="service-icon"><BrushIcon size={56} /></div>
								<h4>Vệ sinh nhà cửa</h4>
								<p>Dọn dẹp, lau chùi, giặt giũ cơ bản, sắp xếp gọn gàng cho căn nhà của bạn.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><ConstructIcon size={56} /></div>
								<h4>Sửa chữa điện điện nước</h4>
								<p>Kiểm tra, khắc phục sự cố điện, ống nước, thiết bị vệ sinh đơn giản tại gia.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><HomeIcon size={56} /></div>
								<h4>Sửa chữa nhà cửa</h4>
								<p>Sơn sửa, trám vá, lắp đặt cơ bản, bảo trì hạng mục nhỏ trong nhà.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><HeartIcon size={56} /></div>
								<h4>Chăm sóc người</h4>
								<p>Hỗ trợ chăm sóc người cao tuổi, người bệnh nhẹ, trông trẻ theo giờ.</p>
							</div>
						</div>
					</section>

					<section className="ldt-section">
						<h2 className="section-title">Gói dịch vụ theo giờ</h2>
						<div className="packages-grid">
							<div className="package-card">
								<div className="package-header">
									<h3>Gói 2 giờ</h3>
									<p className="package-sub">Phù hợp công việc gọn nhẹ</p>
								</div>
								<ul className="package-list">
									<li>Dọn dẹp nhanh khu vực chính</li>
									<li>Kiểm tra/sửa chữa lỗi nhỏ</li>
									<li>Thời gian linh hoạt</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói 3 giờ</h3>
									<p className="package-sub">Xử lý trọn vẹn một đầu việc</p>
								</div>
								<ul className="package-list">
									<li>Vệ sinh chi tiết hơn</li>
									<li>Sửa chữa nhẹ trong nhà</li>
									<li>Tiết kiệm chi phí</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói 4 giờ</h3>
									<p className="package-sub">Nhiều hạng mục trong một lần</p>
								</div>
								<ul className="package-list">
									<li>Dọn dẹp, giặt giũ, sắp xếp</li>
									<li>Kiểm tra điện nước tổng quát</li>
									<li>Linh hoạt theo nhu cầu</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói một ngày</h3>
									<p className="package-sub">Phục vụ trọn ngày cho nhu cầu lớn</p>
								</div>
								<ul className="package-list">
									<li>Dọn dẹp toàn diện</li>
									<li>Sửa chữa nhỏ theo yêu cầu</li>
									<li>Chăm sóc người trong ngày</li>
								</ul>
							</div>
						</div>
					</section>
				</div>
			</section>

			{/* Footer (reuse from Home) */}
			<footer className="home-footer">
				<div className="home-container footer-inner">
					<div className="footer-contact">
						<p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
						<p><strong>Email:</strong> trile@fconnect.vn</p>
						<p><strong>Điện thoại:</strong> 02513684266</p>
						<p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc, Phường Trấn Biên, Tp. Đồng Nai, Việt Nam</p>
						<p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
					</div>
					<div className="footer-stores">
						<a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true"></span>
							<span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
						</a>
						<a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true">▶</span>
							<span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
						</a>
					</div>
				</div>
				<div className="copyright">© 2025 Fconnect. Tất cả các quyền được bảo lưu.</div>
			</footer>
		</div>
	);
};

export default LaoDongPhoThong;


